import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  summary: null,
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSummary(state, action) {
      state.isLoading = false;
      state.summary = action.payload;
    },
  },
});

export default slice.reducer;

const API = process.env.REACT_APP_HOST_API;

// ----------------------------------------------------------------------

export function fetchDashboardSummary() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${API}/dashboard`);
      dispatch(slice.actions.setSummary(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Dashboard/Get/InternalError'));
    }
  };
}
